<header class="header">
  <p-button
    icon="pi pi-bars"
    [text]="true"
    [rounded]="true"
    (onClick)="onMenuToggle()"
    class="menu-toggle"
  />

  <div class="logo-container">
    <img [src]="institution?.logoDirectory" alt="{{ institution?.shortName }} Logo" class="logo" />
    <h1 class="header-title">{{ institution?.shortName }}</h1>
  </div>

  <span class="spacer"></span>

  <p-button
    [icon]="themeService.currentTheme() === 'light' ? 'pi pi-moon' : 'pi pi-sun'"
    [text]="true"
    [rounded]="true"
    (onClick)="toggleTheme()"
    title="Toggle theme"
    class="theme-toggle"
  />

  <p-menu #menu [model]="menuItems" [popup]="true" />
  <p-button
    label="Explorar"
    icon="pi pi-th-large"
    iconPos="left"
    [text]="true"
    (onClick)="menu.toggle($event)"
    class="user-menu-trigger"
  />
</header>
